<button mat-raised-button color="color" [disabled]="disabled()" (click)="onClick()">
  @if (icon()) {
    <mat-icon>{{icon()}}</mat-icon>
  }
  @if (label()) {
    <span>{{label()}}</span>
  }
</button>
